/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/fragments-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/fragments-api-client";
import type { CfrTranscodingStartCfrTranscodingJobMutationRequest, CfrTranscodingStartCfrTranscodingJobMutationResponse, CfrTranscodingStartCfrTranscodingJobPathParams } from "../models/CfrTranscodingStartCfrTranscodingJob";

export function getCfrTranscodingStartCfrTranscodingJobUrl(fragmentId: CfrTranscodingStartCfrTranscodingJobPathParams["fragmentId"]) {
  const res = { method: 'POST', url: `/cfr-transcoding/${fragmentId}/start` as const }  
  return res
}

/**
 * @summary Start CFR transcoding job for a fragment
 * {@link /cfr-transcoding/:fragmentId/start}
 */
export async function cfrTranscodingStartCfrTranscodingJob(fragmentId: CfrTranscodingStartCfrTranscodingJobPathParams["fragmentId"], data?: CfrTranscodingStartCfrTranscodingJobMutationRequest, config: Partial<RequestConfig<CfrTranscodingStartCfrTranscodingJobMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<CfrTranscodingStartCfrTranscodingJobMutationResponse, ResponseErrorConfig<Error>, CfrTranscodingStartCfrTranscodingJobMutationRequest>({ method : "POST", url : getCfrTranscodingStartCfrTranscodingJobUrl(fragmentId).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}